import moment from "moment";
import DeviceDetector from "device-detector-js";

var crc32Map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
var crc32Hash = crc32Map.split(' ').map(function(s){ return parseInt(s,16) });
const statusTypes = {
    1: {id:1, title:"Active", name:"active", html:"<span title='Active' class='status status-active'>🔷</span>"},
    2: {id:2, title:"In Progress", name:"inprogress", html:"<span title='In Progress' class='status status-in-progress'>🔄</span>", style:{backgroundColor:"#2a2113", color:"#f79009"}},
    3: {id:3, title:"Reserved", name:"reserved", html:'<span title="Reserved" class="status status-reserved">🟠</span>', style: {}},
    4: {id:4, title:"Paused", name:"paused", html:'<span title="Paused" class="status status-paused">⏸️</span>', style: {} },
    5: {id:5, title:"Deleted", name:"deleted", html:'<span title="Deleted" class="status status-deleted">🗑️</span>', style:{} },
    6: {id:6, title:"Burned", name:"burned", html:'<span title="Burned" class="status status-burned">🔥</span>', style: {backgroundColor:"#0f221a", color:"#12b76a"}},
    7: {id:7, title:"Complete", name:"complete", html:'<span title="Completed" class="status status-completed">✔️</span>', style:{}},
    8: {id:8, title:"Available", name:"available", html:'<span title="Available" class="status status-avaiable">🟡</span>', style:{}},
    11: {id:11, title:"Specialty 1", name:"specialty", style:{}},
    90: {id:90, title:"Error", name:"error", html:'<div title="Error" class="status status-error">❌</div>', style:{backgroundColor:"#261717", color:"#f04438"}},
}

export default {
    renderGreenRed(isGreen, body) {
        if(typeof isGreen == "boolean")  {
            body = isGreen.toString();
        }
        return (
            <span style={{color: isGreen ? "green" : "red"}}>
                {body}
            </span>
        )
    },
    getDeviceType() {
        const deviceDetector = new DeviceDetector();
        const device = deviceDetector.parse(navigator.userAgent);

        // console.log("device >>>>>", device);

        return device.device.type;
    },
    getClientName() {
        const deviceDetector = new DeviceDetector();
        const device = deviceDetector.parse(navigator.userAgent);

        return device.client.name;
    },
    getOsName() {
        const deviceDetector = new DeviceDetector();
        const device = deviceDetector.parse(navigator.userAgent);

        return device.os.name;
    },
    getOsVersion() {
        const deviceDetector = new DeviceDetector();
        const device = deviceDetector.parse(navigator.userAgent);

        return device.os.version;
    },
    isSmartPhone() {
        return this.getDeviceType() == "smartphone";
    },
    isDesktop() {
        return this.getClientName() == "desktop";
    },
    cssCalc(elOrNum1, elOrNum2) {
        // NOTE: calc(100vh - num);
        if(typeof elOrNum1 === 'string' && typeof elOrNum2 === 'string') {
            return this.getHeightBetweenElements(elOrNum1, elOrNum2);
        }
        if(typeof elOrNum1 === 'string') {
            const el = $(elOrNum1);
            if(el && el.offset()) {
                const elHeight = $(window).height() - el.offset().top;
                // NOTE: keep below to be able to test 1 element
                // if(elOrNum1 == ".aiChatboxSidePanel") {
                //     console.log("elHeight >>>>>", elOrNum1, elHeight);
                // }
                if(isNaN(elHeight)) {
                    return "auto";
                }
                return elHeight;
            }
        }

        if(!elOrNum1) {
            elOrNum1 = 0;
        }
        if(isNaN(elOrNum1)) {
            return "auto";
        }
        return $(window).height() - elOrNum1;
    },
    getHeightBetweenElements(topName, bottomName) {
        // NOTE: eName1 should be BELOW eName2, otherwise result is negative number
        const topElement = $(topName);
        const bottomElement = $(bottomName);

        if(topElement && bottomElement && topElement.offset() && bottomElement.offset()) {
            const topPosition = topElement.offset().top;
            const bottomPosition = bottomElement.offset().top;

            // Calculate the distance between the bottom of topElement and the top of bottomElement
            const distance = Math.abs(bottomPosition - topPosition);

            if(isNaN(distance)) {
                return "auto";
            }
            return distance;
        }

        return "auto";
    },
  isArray(x) {
    return x.constructor.toString().indexOf("Array") > -1;
  },

  _int(num, defaultValue) {
      defaultValue = defaultValue ? defaultValue : 0;

      let output = parseInt(num);

      if(isNaN(output)) {
          output = defaultValue;
      }

      return output;
  },

  getAge(date) {
      let age = moment().diff(date, 'years');
      return age; // NOTE: returns integer "age"
  },

  getRequest(name, defaultVal, url, processPathParams) {
    defaultVal = (defaultVal !== undefined) ? defaultVal : undefined;
    if (!url && window) {
      url = window.location.href;
    } else if(!url && !window) {
      url = "";
    }
    //console.log("getRequest defaultVal", defaultVal, url)
    name = name.replace(/[\[\]]/g, "\\$&");
    var reg = "[?&]" + name + "=([^&#]+)"; //"{(=([^&#]*)|&|#|$)}";
    var regex = new RegExp(reg);
    var results = regex.exec(url);
    //console.log("getRequest results", results, name, reg);
    if (!results) {
        if(processPathParams) {
            var iParams = this.processPathParams();
            if(iParams[name]) {
                return iParams[name];
            }
        }
        return defaultVal;
    }
    if (!results[1]) {
        return defaultVal;
    }
    return decodeURIComponent(results[1].replace(/\+/g, " "));
  },

  processPathParams() {
      const pathName = this.get(window, 'location.pathname');
      let out = {};
      if(!pathName || pathName.indexOf('-') == -1) {
          return out;
      }
      const parts = pathName.split('/');
      for(var idx in parts) {
          const part = parts[idx];
          if(part.indexOf('-') != -1) {
              const param = part.split('-');
              out[param[0]] = param[1];
          }
      }
      return out;
  },

  urlSafeName(titleVal) {
      titleVal = titleVal.toLowerCase();
      titleVal = titleVal.replace(/[^a-z0-9]/gmi, " ").replace(/\s+/g, " ").replace(/ /g,"_");
      return titleVal;
  },

  get(object, path, defaultVal) {
    //console.log("UTILS.GET", object, path, defaultVal);
    window.test = object;
    if(!object || typeof object != "object") {
        return defaultVal;
    }
    if(!path) {
        return defaultVal;
    }
    var parts = path.split(".");
    var cur = object;
    for (var idx in parts) {
      if(!cur) {
          return defaultVal;
      }

      var pathPart = parts[idx];
      if(typeof cur == "object" && pathPart in cur) {
          cur = cur[pathPart];
          if(cur == null) {
              return defaultVal;
          }
      } else {
        return defaultVal;
      }
    }
    return cur;
  },
  set(object, path, val) {
    //console.log("UTILS.set", object, path, val);
    var parts = path.split(".");
    var cur = object;
    var lastIdx = parts.length - 1;
    for(var idx in parts) {
        var pathPart = parts[idx];
        if(idx == lastIdx) {
            cur[pathPart] = val;
            return true;
        } else if(typeof cur == "object" && pathPart in cur) {
            cur = cur[pathPart];
        } else {
            console.log("UTILS.set PATH NOT FOUND", object, path, val);
            return false;
        }
    }
    return false;
  },
  isObjectEmpty(obj) {
      return Object.keys(obj).length === 0;
  },
  commas(x) { // NOTE: 1,000 dollars money
    return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : x;
  },
  formatMoney(amount) {
    // Convert the input to a number first to handle inputs like strings or numbers
    const numberAmount = Number(amount);
    // Use toFixed(2) to ensure two decimal places
    if(isNaN(numberAmount)) {
        return "";
    }
    return numberAmount.toFixed(2);
  },


  arrayToObject(inArray, pathToId, outObject) {
    var outObject = outObject ? outObject : {};

    for (var idx in inArray) {
      var item = inArray[idx];

      var id = this.get(item, pathToId);
      if (id || id == 0) {
        outObject[id] = item;
      } else {
        //console.log("No arrayToObject ID: " + pathToId, JSON.stringify(item));
      }
    }
    return outObject;
  },

  setCookie(name, value, days, minutes) {
        var expires;

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else if(minutes) {
            var date = new Date();
            date.setTime(date.getTime() + (minutes * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";

        return value;
  },

  getCookie(name, defaultVal) {
    defaultVal = defaultVal == undefined ? null : defaultVal;
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return defaultVal;
  },

  deleteCookie(name) {
    this.setCookie(name, "", -1);
  },
  padZeros(num, size) {
      num = num.toString();
      while (num.length < size) num = "0" + num;
      return num;
  },
  formatBirthdate(dayText, monthText, yearText) {
      return `${yearText}-${this.padZeros(monthText, 2)}-${this.padZeros(dayText, 2)}`;
  },

  calcTimeStr(now, then, format) {
      let timeStr = "";
      const dropMinutes = then.diff(now, 'minutes');
      const dropHours = then.diff(now, 'hours');
      const dropDays = then.diff(now, 'days');
      if(format == "dhm") {
            if(dropDays > 0) {
                timeStr = dropDays + (dropDays == 1 ? " day" : " days");
            }
              timeStr += " " + (dropHours % 24) + ((dropHours % 24) == 1 ? " hour" : " hours");
              timeStr += " " + (dropMinutes % 60) + ((dropMinutes % 60) == 1 ? " minute" : " minutes");
      } else if(format == "dhm_short") {
            if(dropDays > 0) {
                timeStr = dropDays + "d";
            }
              timeStr += " " + (dropHours % 24) + "h";
              timeStr += " " + (dropMinutes % 60) + "m";
      } else {
          if(dropHours > 24) {
              timeStr = dropDays + (dropDays == 1 ? " day" : " days");
          } else if(dropMinutes > 60) {
              timeStr = dropHours + (dropHours == 1 ? " hour" : " hours");
          } else {
              timeStr = dropMinutes + (dropMinutes == 1 ? " minute" : " minutes");
          }
      }
      return timeStr;
  },
    secondsToTimeString(totalSeconds, format) {
        const seconds = totalSeconds % 60;
        const minutes = Math.floor(totalSeconds / 60) % 60;
        let hours = Math.floor(totalSeconds / (60 * 60)) % 24;
        const days = Math.floor(totalSeconds / (60 * 60 * 24));

        const secondsString = seconds === 1 ? "second" : "seconds";
        const minutesString = minutes === 1 ? "minute" : "minutes";
        let hoursString = hours === 1 ? "hour" : "hours";
        const daysString = days === 1 ? "day" : "days";

        switch(format) {
            case "dhm":
                return `${days <= 0 ? "" : days} ${days <= 0 ? "" : daysString} ${hours <= 0 ? "" : hours} ${hours <= 0 ? "" : hoursString} ${minutes <= 0 ? "" : minutes} ${minutes <= 0 ? "" : minutesString}`;
            case "dhm_obj":
                hours = Math.floor(totalSeconds / (60 * 60));
                hoursString = hours === 1 ? "hour" : "hours";
                return {
                    days: days <= 0 ? "00" : days,
                    daysString: daysString,

                    hours: hours <= 0 ? "00" : hours,
                    hoursString: hoursString,

                    minutes: minutes <= 0 ? "00" : minutes,
                    minutesString: minutesString,

                    seconds: seconds <= 0 ? "00" : seconds,
                    secondsString: secondsString,
                };
            case "dhms":
                return `${days} ${daysString} ${hours} ${hoursString} ${minutes} ${minutesString} ${seconds} ${secondsString}`;
            case "dhm_short":
                return `${days}d ${hours}h ${minutes}m`;
            case "hms_short":
                return `${hours <= 0 ? "" : hours+"h"} ${minutes <= 0 ? "" : minutes+"m"} ${seconds}s`;
            case "dhms_short":
                return `${days}d ${hours}h ${minutes}m ${seconds}s`;
            default:
                return "";
        }
    },
    convertTimeToMinutesAndSeconds(startTime, endTime) {
        let startTimeParts = this.stringToHoursAndMinutes(startTime);
        let endTimeParts = this.stringToHoursAndMinutes(endTime);
        let startHours = endTimeParts[0] - startTimeParts[0];
        let startMinutes = endTimeParts[1] - startTimeParts[1];
        let startSeconds = endTimeParts[2] - startTimeParts[2];

        if(startMinutes < 0) {
            startMinutes = 60 + startMinutes;
        }

        const totalSeconds = (startHours * 60 * 60) + (startMinutes * 60) + startSeconds;

        return this.secondsToTimeString(totalSeconds, "hms_short");
    },
    stringToHoursAndMinutes(time) {
        let parts = [];
        let seconds = null;
        let minutes = null;
        let hours = null;
        time += ""; // convert time to string

        if(time.includes(":")) {
            parts = time.split(":");

            hours = parts[0];
            minutes = parts.length > 1 ? parts[1] : 0;
            seconds = parts.length > 2 ? parts[2] : 0;
        } else {
            hours = time;
            minutes = "00";
            seconds = "00";
        }

        return [hours, minutes, seconds]
    },
    getTimeFromDate(createdAt) {
        if(!createdAt) {
            return "";
        }
        const createdParts = createdAt.split(' ');
        let dateParts = [2021, 10, 22];
        if(createdParts[0].indexOf("-") != -1) {
            dateParts = createdParts[0].split('-');
        }
        let timeParts = [0,0,0];
        if(createdParts.length > 1 && createdParts[1].indexOf(":") != -1) {
            timeParts = createdParts[1].split(':');
        }

        return moment.utc([
            dateParts[0],
            dateParts[1],
            dateParts[2],
            timeParts[0],
            timeParts[1],
            timeParts[2]
        ]).local().format("LT");
    },
    time(format, dateObj) {
        dateObj = dateObj ? dateObj : new Date();
        format = format ? format : "MMMM DD, YYYY";
        return moment(dateObj).format(format);
    },
    getFomattedDateFromCreatedAt(createdAt, isTime) {
        if(isTime) {
            // return moment.utc(createdAt).format("MMMM Do, LT").replace(/(:|\.)[0-9]{2}/, '');
            return moment.utc(createdAt).format("MMMM Do");
        } else {
            return moment.utc(createdAt).format("MMMM DD, YYYY");
        }
    },
    randInt(min, max) {
        min = min ? min : 1000;
        max = max ? max : 9999;

        return Math.floor(Math.random() * (max - min + 1) + min);
    },

  pluck(inArray, idField) {
      var outArray = [];
      idField = idField ? idField : "id";
      for(var idx in inArray) {
          var item = inArray[idx];
          if(idField in item) {
              outArray.push(item[idField]);
          }
      }
      return outArray;
  },
    getUrlCrc(defaultCrc, propsHistory) {
        let pathname = "";

        if(propsHistory) {
            pathname = this.get(propsHistory, "location.pathname")
        } else if(window.location) {
            pathname = window.location.pathname;
        }
        let id = false;
        if(pathname.indexOf('-') != -1) {
            let urlParts = pathname.split("-");
            id = urlParts[urlParts.length - 1];
        }

        if(id) {
            return id;
        } else {
            return defaultCrc;
        }

        return false;
    },
    getUrlPathPart(num) {
      let pathname = window.location.pathname;
      let urlParts = pathname.split("/");
      if(urlParts.length-1 >= num) {
          return urlParts[num];
      } else {
          return false;
      }
    },
    addErrorSuccessMessage(id, message, noArray) {
        if(noArray) {
            return {
                id: id,
                message: message,
            };
        }

        return [{
            id: id,
            message: message,
        }];
    },
    formatPhoneNumber(phone) {
        if(!phone || phone.length == 0) {
            return "";
        }
        let areaCode = phone.substring(0,3);
        let firstThree = phone.substring(3,6);
        let lastFour = phone.substring(6);

        let outsideUSA = false;
        let countryCode = "+ 1";

        if(outsideUSA) {
            countryCode = "something else";
        }

        if(phone.length == 10) {
            return `${countryCode} (${areaCode}) ${firstThree} – ${lastFour}`;
        } else {
            return `${phone}`;
        }
    },

    shortenString(str, count, useWordBoundary) {
        if(!str || str.length == 0) {
            return "";
        }
        if (str.length <= count) { return str; }
        const subString = str.slice(0, count-1); // the original check
        return (useWordBoundary
            ? subString.slice(0, subString.lastIndexOf(" "))
            : subString) + "...";
    },
    crc32(str) {
        var crc = -1;
        for(var i=0, iTop=str.length; i<iTop; i++) {
            crc = ( crc >>> 8 ) ^ crc32Hash[( crc ^ str.charCodeAt( i ) ) & 0xFF];
        }
        return (crc ^ (-1)) >>> 0;
    },
    pad(num, size, padChar) {
        padChar = padChar ? padChar : "0";
        var s = num+"";
        while (s.length < size) s = padChar + s;
        return s;
    },
    getBrowserId(shortId) {
        shortId = shortId ? shortId : false;
        let bid = -1;
        let agentSettings = "";

        if(navigator) {
          if(navigator.userAgent) {
              agentSettings += navigator.userAgent;
          }
          if(navigator.userAgentData) {
              agentSettings += JSON.stringify(navigator.userAgentData);
          }
          bid = this.crc32(agentSettings);
        }
        if(shortId) {
            bid = (bid+"").substr(-3);
        }
        return bid;
    },
    abbreviateHash(walletId, len, seperator, abbrLocation) {
        if(!walletId) {
            return "";
        }
        abbrLocation = abbrLocation ? abbrLocation : "middle";
        len = len ? len : 6;
        seperator = seperator ? seperator : "...";

        if(walletId.length > len && abbrLocation === "end") {
            return walletId.substr(0,len) + seperator;
        } else {
            if(walletId.length > (2*len)) {
                return walletId.substr(0,len) + seperator + walletId.substr(-1*len);
            } else {
                return walletId;
            }
        }
    },
    activateLogger() {
        // NOTE pushLogsToServer() is in Api.js
        window.Utils = this;
        // NOTE Make sure logger isn't already created
        if(!window.consolelog) {
            try {
                window.consolelog = console.log;
                var maxLength = 500;
                // If max length is exceeded, truncate to newLength entries
                var newLength = -250;
                // Take over console.log and store entries to array
                console.log = function(o) {
                    if(!window.logs) {
                        window.logs = [];
                    } else if(window.logs.length > maxLength) {
                        window.logs = window.logs.slice(newLength);
                    }
                    // Arguments is readonly and we need the timestamp, so...
                    var myArray = [Date.now(),window.location.pathname];
                    for(var idx in arguments) {
                        myArray.push(arguments[idx]);
                    }
                    window.logs.push(myArray);
                    window.consolelog.apply(console, arguments);
                };
                window.onerror =
                      function (msg, source, lineNo, columnNo, error) {
                        console.log("Error: " + msg +
                              "\nScript: " + source +
                              "\nLine: " + lineNo +
                              "\nColumn: " + columnNo +
                              "\nStackTrace: " + error);
                        return true;
                    };
            } catch (error) {
                console.log("ERROR setting up logger", error);
            }
        }
    },
    safeStringify(o) {
        var cache = [];
        var out = JSON.stringify(o, function(key, value) {
            if (typeof value === 'object' && value !== null) {
                if (cache.indexOf(value) !== -1) {
                    // Circular reference found, discard key
                    return;
                }
                // Store value in our collection
                cache.push(value);
            }
            return value;
        });
        cache = null; // Enable garbage collection
        return out;
    },

    serializeLogs(clearLogs) {
        var out = [];
        if(!window.logs) {
            return out;
        }
        try {
            for(var idx in window.logs) {
                var logItem = window.logs[idx];
                if(false) {
                    var line = []; //JSON.stringify(logItem);
                    for(var idx2 in logItem) {
                        if(typeof logItem[idx2] == 'string' || typeof logItem[idx2] == "number") {
                            line.push("" + logItem[idx2]);
                        } else {
                            line.push(JSON.stringify(logItem[idx2]));
                        }
                    }
                }
                out.push(this.safeStringify(logItem));
            }
        } catch (error) {
            console.log("ERROR serializeLogs logger", error);
        }
        if(clearLogs) {
            window.logs = [];
        }
        return out;
    },

    getCircularReplacer() {
      const seen = new WeakSet();
      return (key, value) => {
        if (typeof value === "object" && value !== null) {
          if (seen.has(value)) {
            return;
          }
          seen.add(value);
        }
        return value;
      };
    },
    setPropsHistory(history) {
        this.propsHistory = history;
    },
    urlContainsString(pr, str) {
        return pr.history.location.pathname?.includes(str) ?? false;
    },
    splitUrl(pr, separator) {
        if(!separator) {
            separator = "/";
        }
        let pathName = this.get(pr, "history.location.pathname", "");
        if(pathName[0] == "/") {
            pathName = pathName.slice(1);
        }
        return pathName.split(separator);
    },

    isDemoMode() {
        return this.getCookie('demomode') == 1;
    },

    getKeyByValue(object, value) {
        return Object.keys(object).find(key => object[key] === value);
    },

    newTab(link) {
        window.open(link, "_blank");
    },
    getIndexesOf(searchStr, str, caseSensitive) {
        var searchStrLen = searchStr.length;
        if (searchStrLen == 0) {
            return [];
        }
        var startIndex = 0, index, indexes = [];
        if (!caseSensitive) {
            str = str.toLowerCase();
            searchStr = searchStr.toLowerCase();
        }
        while ((index = str.indexOf(searchStr, startIndex)) > -1) {
            indexes.push(index);
            startIndex = index + searchStrLen;
        }
        return indexes;
    },
    arrayToObjectReducer(arr, key, val) {
        let reducedArray = arr.reduce((obj, item) => (obj[item[key]] = item[val], obj) ,{});

        return reducedArray;
    },
    deepCopy(obj1, isArray) {
        if(isArray) {
            return $.extend(true, [], obj1);
        } else {
            return $.extend(true, {}, obj1);
        }
    },
    toCamelCase(str, char) {
        let camelCaseStr = str;
        let splitStr = str.split(char);
        if(splitStr.length > 1) {
            let upperCaseStr = splitStr[1].charAt(0).toUpperCase() + splitStr[1].slice(1);
            camelCaseStr = splitStr[0] + upperCaseStr;
        }

        return camelCaseStr;
    },
    toTitleCase(str) {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    toTitleCase2(str) {
        let parts = str.split(" ");
        let out = [];
        for(let idx in parts) {
            let curChar = parts[idx].trim();
            if(curChar.length) {
                out.push(curChar.charAt(0).toUpperCase() + curChar.slice(1).toLowerCase());
            }
        }
        return out.join(" ");
    },
    uniqueKey(keyName, indexText) {
        return `${keyName}-${this.crc32(indexText)})`;
    },

    getNextPath(pr) {
        let nextPathname = this.get(pr, "history.location.pathname");
        nextPathname = nextPathname.substring(1);
        return `?next=${nextPathname}`;
    },

    getCollectionOrCollectibleUrl(collectionId, collectibleId) {
        let url = "";

        if(collectionId) {
            url = `/p/afterparty_livestreams/collection-${collectionId}`;
            if(collectibleId) {
                url += `/collectible-${collectibleId}`;
            }
        } else  {
            url = `/p/digital_collectible/collectible-${collectibleId}`;
        }

        return url;
    },

    gotoRoute(pr, link, target, ignoreNextPath) {
        console.log("gotoRoute", pr, link, target);
        // Link examples: /login /webapp/login p/community /p/community /webapp/p/community
        let fullPath = link.substr(0,4) == 'http' ? true : false;
        console.log("goto", pr.history, fullPath, link, pr);
        //return;
        // Remove forward slash for each checking of route, will be restored later
        const originalLink = link;
        if(!fullPath) {
            link = link.substr(0,1) == '/' ? link.substr(1) : link;
        }

        if(target != '_blank') {
            target = false;
        }

        if(link == "festival") {
            window.open("http://afterparty.com/sl/festival", "_blank");
            return;
        } else if(link == "login") {
            if(!ignoreNextPath && this.getNextPath) {
                link += this.getNextPath(pr);
            }
        } else if(link == "register" && this.getNextPath) {
            link += this.getNextPath(pr);
        } else if (link.indexOf("mailto:") != -1) {
            target = "location";
        }

        switch (target) {
            case "_blank":
                window.open(originalLink, "_blank");
                break;
            case "window":
                document.location.href = link;
                break;
            case "location":
                window.location = link;
                break;
            default:
                // Restore slash if needed
                link = link.substr(0,1) != '/' ? "/" + link : link;
                console.log("goto", pr.history, fullPath, link);
                pr.history.push(link);
                // TODO: Only reload if staying on top level component like post
                pr.history.go();
        }
    },

    detectInAppBrowser(ua) {
        ua = ua.toLowerCase().trim();
        const isIOS =
            ua.includes('iphone') || ua.includes('ipod') || ua.includes('ipad');
        const isAndroid = ua.includes('android');

        // iOS Chrome
        if (ua.includes('crios')) {
            return 'is_chrome_ios';
        }

        // Facebook
        if (ua.includes('fbios') || ua.includes('fb_iab')) {
            return isIOS
            ? 'is_facebook_ios'
            : isAndroid
            ? 'is_facebook_android'
            : 'is_facebook_unknown';
        }

        // Instagram
        if (ua.includes('instagram')) {
            return isIOS
            ? 'is_instagram_ios'
            : isAndroid
            ? 'is_instagram_android'
            : 'is_instagram_unknown';
        }

        // LINE
        if (ua.includes(' line/')) {
            return isIOS
            ? 'is_line_ios'
            : isAndroid
            ? 'is_line_android'
            : 'is_line_unknown';
        }

        // iOS Safari|Twitter|Slack|Discord|etc
        if (isIOS && /safari\/[0-9.]+$/.test(ua)) {
            return 'maybe_safari_ios';
        }

        // Android Chrome|Twitter|Slack|Discord|etc
        if (isAndroid && ua.includes('chrome') && /safari\/[0-9.]+$/.test(ua)) {
            return 'maybe_chrome_android';
        }

        return null;
    },

    formatUsername(username) {
        if(!username || username.length == 0) {
            return "";
        }
        let a = username.split("_");
        if(a.length > 1 && Number.isInteger(parseInt([a.length - 1])) ) {
            delete a[a.length - 1]
        }

        if(a.length > 1) {
            return a.join("_").slice(0, -1);
        } else {
            return a[0];
        }
    },
    generateClientUid(customerId) {
        customerId = parseInt(customerId);
        const browserId = this.getBrowserId(true);
        const customerIdPadded = this.pad(customerId, 6);
        let clientUid = `${browserId}${customerIdPadded}`;
        clientUid = parseInt(clientUid);
        return clientUid;
    },
    processClientUid(clientUid) {
        const customerId = parseInt((clientUid+"").substr(-6));
        const browserPrefix = parseInt((clientUid+"").substr(-3));
        // return [parseInt((uid+"")), 17];
        return [customerId, browserPrefix];
    },
    addMultiTabCheck(hash, alreadyOpenCallback) {
        var attr = "openpages|"+hash;
        var attr2 = "page_available|"+hash;
        localStorage[attr] = Date.now();
        window.addEventListener('storage', function (e) {
            if(e.key == attr) {
                // Listen if anybody else is opening the same page!
                localStorage[attr2] = Date.now();
            }
            if(e.key == attr2) {
                if(alreadyOpenCallback) {
                    return alreadyOpenCallback();
                }
            }
        }, false);
    },
    getUnixTimestamp() {
        return parseInt(new Date().valueOf()/1000);
    },
    empty(val, name) {
        if(!val) {
            return true;
        }
        if(typeof val == 'string') {
            val = val.trim();
            if(val.length == 0 || val == "undefined" || val == "null") {
                return true;
            }
        }
        if(typeof val == 'object') {
            const keys = Object.keys(val);
            if(name) {
                console.log(`Checking empty: ${name} val:${val} keys:${keys}`)
            }
            if(keys.length == 0) {
                return true;
            }
        }
        return false;
    },
    userIsLoadedAndExists(pr) {
        const isLoaddedAndExists = pr.userLoaded && Boolean(this.get(pr, "user.email", ""));

        return isLoaddedAndExists;
    },
    symmetricalEncode(input, key) {
        let output = '';
        for (let i = 0; i < input.length; i++) {
            const charCode = input.charCodeAt(i);
            const keyCode = key.charCodeAt(i % key.length);  // loop over key if it's shorter than input
            const encodedChar = charCode ^ keyCode;          // XOR operation
            output += String.fromCharCode(encodedChar);
        }
        return output;
    },
    copyUrl(callback) {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(window.location.href)
                .then(() => {
                    callback();
                })
                .catch(err => console.error('Failed to copy URL: ', err));
        } else {
            // Fallback method for older browsers
            const textField = document.createElement('textarea');
            textField.innerText = window.location.href;
            document.body.appendChild(textField);
            textField.select();
            document.execCommand('copy');
            textField.remove();
        }

    },
    getCurrentUrl() {
        return this.get(window, "location.href");
    },

    shareTray(title, text, url) {
        if(navigator.share) {
            navigator.share({
                title: title ?? 'Example Title',
                text: text ?? 'Example text',
                url: url ?? 'https://google.com',
            })
            .then(() => alert('Share was successful.'))
            .catch((error) => console.log('Error sharing: ' + error));
        } else {
            console.log('Web Share API is not supported in this browser.');
        }
    },

    parameterSubstitute(str, obj, defaultVal, filterRegex) {
        defaultVal = defaultVal == undefined ? "" : defaultVal;
        let result = str;
        let regex = /{([^}]+)}/g;
        if(filterRegex) {
            regex = filterRegex;
        }
        let match = regex.exec(str);
        while(match) {
            const param = match[1];
            //console.log("Utils parameterSubstitute", param);
            const val = this.get(obj, param);
            const value = val == undefined ? defaultVal : val;

            result = result.replace(match[0], value);
            match = regex.exec(str);
        }
        return result;
    },
    findKeyPath(obj, searchValue, isNumber) {
        searchValue = isNumber && !isNaN(searchValue) ? parseInt(searchValue) : searchValue;
        const queue = [{ obj, path: '' }];
        const results = [];

        while (queue.length > 0) {
            const { obj, path } = queue.shift();

            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    const newPath = path ? `${path}.${key}` : key;

                    if (Array.isArray(obj[key])) {
                        obj[key].forEach((item, index) => {
                            queue.push({ obj: item, path: `${newPath}.${index}` });
                        });
                    } else if (typeof obj[key] === 'object' && obj[key] !== null) {
                        queue.push({ obj: obj[key], path: newPath });
                    } else if (obj[key] === searchValue) {
                        results.push(newPath);
                    }
                }
            }
        }

        let resultsString = results.length > 0 ? results.join('\n') : null;
        return resultsString;
    },
    setHtmlScroll(val) {

    },
    titleCase(str) {
      return str.replace(/\b\w/g, function(txt) {
        return txt.toUpperCase();
      });
    },
    getStatusTypes() {
        return statusTypes;
    }
}
